import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 'AU';

const slice = createSlice({
  name: 'countryCode',
  initialState,
  reducers: {
    setCountryCode(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setCountryCode } = slice.actions;

export default slice.reducer;
